import { Box, Text } from "@chakra-ui/react";
import HomeContent from "../Components/HomeContent";
import Events from "../Components/Event";
import Banner from "../Components/Baner";
import YourSupport from "../Components/YourSupport";
import { useEffect } from "react";
import axios from "axios";
import VisitEvent from "../Components/VisitEvent";
const Home = () => {
 return (
  <>
   <Banner />
   <HomeContent />
   <VisitEvent/>
   <Events />
   {/* <Certification  /> */}
   <YourSupport />
  </>
 );
};

export default Home;
